module.exports = __webpack_public_path__ + "static/img/menu-icon.fa93e469.svg";